// src/config/theme.js

/**
 * Paleta de colores oficiales de Axon Capital.
 * Basado en el Manual de Identidad Visual.
 * Se utilizan nombres semánticos para facilitar su uso y mantenimiento.
 */
const colors = {
    // Colores primarios y de marca
    primary: '#1A283E',      // Azul Axon: para fondos de header, botones principales y elementos destacados.
    secondary: '#0D1A29',    // Negro Axon: ideal para textos principales por su alta legibilidad.
    
    // Colores de texto
    textPrimary: '#FFFFFF',  // Texto sobre fondos oscuros (ej. sobre color primario).
    // Texto secundario del manual (Azul 80 %): apoyo, labels e información no crítica
    // sobre fondos claros. El Gris Axon (#8A94A6) da 2,9:1 sobre blanco y el manual
    // no lo admite para texto chico.
    textSecondary: '#465163',
    // Texto de apoyo y líneas sobre fondos oscuros (encabezado, splash, avisos): ahí
    // el Gris Axon sí se lee (≈ 4,8:1 sobre el Azul Axon).
    textSecondaryOnDark: '#8A94A6',
    
    // Colores de UI (Interfaz de Usuario)
    background: '#F6F7F6',   // Blanco Axon: color principal para el fondo de la aplicación.
    surface: '#FFFFFF',      // Color para superficies elevadas como cards, modales y tablas.
    border: '#E5E7EB',       // Gris claro para bordes sutiles y separadores.

    // Colores de estado semánticos (para feedback al usuario)
    success: 'rgba(34, 197, 94, 0.15)',      // Verde para operaciones exitosas o estados positivos.
    warning: 'rgba(252, 211, 77, 0.25)',     // Amarillo para advertencias o estados pendientes.
    error: 'rgba(239, 68, 68, 0.15)',        // Rojo para errores o estados negativos.
    errorText: '#DC2626',                    // Texto rojo para mensajes de error.
};

/**
 * Tipografía oficial de Axon Capital.
 * Basado en el Manual de Identidad Visual.
 * Se definen las familias para títulos, cuerpo de texto y el logo.
 */
const typography = {
    fontFamily: "'Roboto', sans-serif",      // Para todo el texto de párrafos y contenido principal.
    titleFamily: "'Raleway', sans-serif",    // Para todos los títulos (h1, h2, h3...).
    logoFamily: "'Poppins', sans-serif",     // Uso exclusivo para el logo "axon capital".
};

/**
 * Objeto principal del tema.
 * Contiene todos los tokens de diseño (colores, tipografía, sombras, etc.)
 * para ser utilizados en toda la aplicación a través de Styled Components.
 * Se exporta por defecto para una importación limpia.
 */
export const theme = {
    colors,
    typography,
    shadows: {
        soft: '0 4px 12px rgba(0, 0, 0, 0.08)', // Sombra sutil para dar profundidad a elementos como cards.
    },
    borderRadius: '6px', // Radio de borde estándar para botones, inputs y contenedores.
};

// No es necesario exportar 'colors' y 'typography' por separado si ya están en 'theme'.
// export default theme; // Puedes usar export default si prefieres `import theme from './theme'`